import { Box } from '@mui/material'
import Tab from '../../shared/UI/Tab'
import AbsenceDrawerComponent from '../AbsenceDrawerComponent'
import LateDrawerComponent from '../LateDrawerComponent'
import actionsService from '../../services/actionsService'

function AbsenceAndLate() {
  const handleTabChange = (index: number) => {
    const tabName = index === 0 ? 'Absence' : 'Late'
    actionsService.userAnalytics
      .postEvent('UIClickEvent', `Reporting${tabName}TabClick`, window.location.pathname, window.location.hostname)
      .catch((error: unknown) => console.error('Analytics tracking error:', error))
  }

  return (
    <>
      <Tab
        onChange={handleTabChange}
        titleAndContent={[
          {
            label: 'Absence',
            tabContext: (
              <Box mt={4}>
                <AbsenceDrawerComponent />
              </Box>
            ),
            disabled: false,
          },
          {
            label: 'Late',
            tabContext: <LateDrawerComponent />,
            disabled: false,
          },
        ]}
      />
    </>
  )
}

export default AbsenceAndLate
